/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_Week_ClosedInputs */

const en_us2_engagement_week_closed = /** @type {(inputs: Engagement_Week_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week closed. Nicely done!`)
};

const pt_br2_engagement_week_closed = /** @type {(inputs: Engagement_Week_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana fechada. Mandou bem!`)
};

const es_419_engagement_week_closed = /** @type {(inputs: Engagement_Week_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana cerrada. ¡Bien hecho!`)
};

const pt_pt2_engagement_week_closed = /** @type {(inputs: Engagement_Week_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semana fechada. Muito bem!`)
};

const fr_fr2_engagement_week_closed = /** @type {(inputs: Engagement_Week_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semaine bouclée. Bien joué !`)
};

const de_de2_engagement_week_closed = /** @type {(inputs: Engagement_Week_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woche geschafft. Stark!`)
};

const it_it2_engagement_week_closed = /** @type {(inputs: Engagement_Week_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settimana chiusa. Ottimo lavoro!`)
};

/**
* | output |
* | --- |
* | "Week closed. Nicely done!" |
*
* @param {Engagement_Week_ClosedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_week_closed = /** @type {((inputs?: Engagement_Week_ClosedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_Week_ClosedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_week_closed(inputs)
	if (locale === "es-419") return es_419_engagement_week_closed(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_week_closed(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_week_closed(inputs)
	if (locale === "de-DE") return de_de2_engagement_week_closed(inputs)
	if (locale === "it-IT") return it_it2_engagement_week_closed(inputs)
	return en_us2_engagement_week_closed(inputs)
});
export { engagement_week_closed as "engagement.week_closed" }